import React from "react";
import { Caption1 } from "@activecollab/components";
import PropTypes from "prop-types";
import { billableStatusLabels } from "~/utils/tracking";
import { hoursFormatted } from "~/utils/utils";

export const HeaderTooltip = ({ notBillable, billable, pendingPayment, paid }) => {
  return (
    <div>
      {notBillable ? (
        <Caption1 color="only-white">
          {billableStatusLabels[0]}: {hoursFormatted({ hours: 0, minutes: notBillable }, false, true)}h
        </Caption1>
      ) : null}
      {billable ? (
        <Caption1 color="only-white">
          {billableStatusLabels[1]}: {hoursFormatted({ hours: 0, minutes: billable }, false, true)}h
        </Caption1>
      ) : null}
      {pendingPayment ? (
        <Caption1 color="only-white">
          {billableStatusLabels[2]}: {hoursFormatted({ hours: 0, minutes: pendingPayment }, false, true)}h
        </Caption1>
      ) : null}
      {paid ? (
        <Caption1 color="only-white">
          {billableStatusLabels[3]}: {hoursFormatted({ hours: 0, minutes: paid }, false, true)}h
        </Caption1>
      ) : null}
    </div>
  );
};

HeaderTooltip.propTypes = {
  notBillable: PropTypes.number,
  billable: PropTypes.number,
  pendingPayment: PropTypes.number,
  paid: PropTypes.number,
};
